module.exports = __webpack_public_path__ + "static/media/bg_referral_platforms.a30ab226.png";